function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import { StyledSignupWithTextComponent } from "./signup-with-text-component.scss";
class SignupWithTextComponent extends PureComponent {
    renderTexts() {
        const { title, subtitle, isFirstSegment } = this.props;
        const TitleTag = isFirstSegment ? "h1" : "h2";
        const SubtitleTag = isFirstSegment ? "h2" : "h3";
        return /*#__PURE__*/ _jsxs("div", {
            className: "signup-texts",
            children: [
                title && /*#__PURE__*/ _jsx("div", {
                    className: "signup-form-title",
                    children: /*#__PURE__*/ _jsx(TitleTag, {
                        children: title
                    })
                }),
                subtitle && /*#__PURE__*/ _jsx("div", {
                    className: "signup-form-subtitle",
                    children: /*#__PURE__*/ _jsx(SubtitleTag, {
                        children: subtitle
                    })
                })
            ]
        });
    }
    renderForm() {
        return /*#__PURE__*/ _jsx(SignupFormComponent, _object_spread({}, this.props));
    }
    render() {
        const { subtitle, textUnderButtons } = this.props;
        return /*#__PURE__*/ _jsxs(StyledSignupWithTextComponent, {
            className: classnames("signup-form-wrapper", {
                "with-subtitle": subtitle,
                "text-under-buttons": textUnderButtons
            }),
            children: [
                textUnderButtons ? this.renderForm() : this.renderTexts(),
                textUnderButtons ? this.renderTexts() : this.renderForm()
            ]
        });
    }
    constructor(props){
        super(props);
    }
}
export { SignupWithTextComponent as default };
SignupWithTextComponent.defaultProps = {
    textUnderButtons: false
};
